module.exports = __webpack_public_path__ + "static/base10-team-crop-83aa2e4bf210a34399dc0ced34f16d4b.jpg";